import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {

    getAlGroupsForDropdown,
    getEstatesByGroupID,
    getDivisionByEstateID,
    getFieldsByDivisionID,
    getAllTaskNames,
    getLabourTaskByOperationEntityIDTaskCategoryID,
    getDailyTaskDetailReportData,
    GetAllOperationEntityByGroupID
};


async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function GetAllOperationEntityByGroupID(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntityByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}

async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return estateArray;
}


async function getDivisionByEstateID(operationEntityID) {
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true && item[1]["operationEntityID"] == operationEntityID) {
        array[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return array;
}

async function getFieldsByDivisionID(divisionID) {
    var divisionArray = [];
    const response = await CommonGet('/api/Field/GetFieldsByCollectionPointID', 'id=' + divisionID);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            divisionArray[item[1]["fieldID"]] = item[1]["fieldName"]
        }
    }
    return divisionArray;

}

async function getAllTaskNames(groupID, estateID) {
    const response = await CommonGet('/api/EstateTask/GetEstateTaskByFilter', 'groupID=' + groupID + '&operationEntityID=' + estateID);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
        array[item[1]["estateTaskId"]] = item[1]["estateTaskName"]
        }
    }
    return array;
}

async function getLabourTaskByOperationEntityIDTaskCategoryID(estateID, category) {
    const response = await CommonGet('/api/EmployeeTask/GetTaskDetailByOperationEntityID', 'operationEntityID=' + estateID + '&category=' + category);
    return response.data;
}

async function getDailyTaskDetailReportData(data) {
    
    var model = {
        estateID: parseInt(data.estateID),
        divisionID: parseInt(data.divisionID),
        fieldID:parseInt(data.fieldID),
        searchDate: data.searchDate,
        category: parseInt(data.category),
        task: parseInt(data.task)
    };
    const response = await CommonPost('/api/DailyTaskDetailReport/SundryFactoryCheckListNew', null, model);
    return response.data;
}
